<div class="flex flex-col w-full h-full gap-4 p-4 rounded-xl bg-white">
  <div class="flex items-center gap-2">
    <nz-switch
      [ngModel]="onlyWithIntervention()"
      (ngModelChange)="toggleOnlyWithIntervention($event)"
    ></nz-switch>
    <span class="text-sm text-gray-700">{{ 'users.ehr.onlyWithIntervention' | translate }}</span>
  </div>
  <nz-table
    nzBordered
    nzShowSizeChanger
    [nzData]="data()"
    [nzFrontPagination]="false"
    [nzLoading]="loading"
    [nzTotal]="total()"
    [nzPageSize]="pageSize()"
    [nzPageIndex]="page()"
    (nzQueryParams)="paginatorChange($event)"
    [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
    nzTableLayout="auto"
    [nzScroll]="{ x: '84vw' }"
  >
    <thead>
    <tr>

      <th nzLeft nzWidth="110px">სტატუსი</th>
      <th nzWidth="180px">ვიზიტი</th>
      <th nzLeft nzWidth="200px">ბარათის #</th>
      <th nzWidth="200px">ფილიალი</th>
      <th nzWidth="200px">მომხმარებელი</th>
      <th nzWidth="150px">საიდენტ. #</th>
      <th nzWidth="200px">თანამშრომელი</th>
      <th nzWidth="150px">ICD კოდი</th>
      <th nzWidth="110px">EHR ID</th>
      <th nzWidth="280px">ჰოსპიტალიზაციის შედეგი</th>

      <th nzWidth="180px">თარიღი</th>
      <th nzRight nzWidth="80px"></th>
    </tr>
    </thead>
    <tbody>
      @for (item of data(); track item.id) {
        <tr>

          <td nzLeft>
            <div
              class="text-[12px] text-center p-0.4 rounded-full "
              [ngClass]="statusClass()(item.status)"
            >
              {{ item.status | ehrStatus }}
            </div>
          </td>
          <td>{{ item.EHRStartDate | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td nzLeft>{{ item.ehrNo }}</td>
          <td>{{ item.branch?.name }}</td>
          <td>{{ item.user?.firstName }} {{ item.user?.lastName }}</td>
          <td>{{ item.user?.idNumber }}</td>
          <td>{{ item.employee?.firstName }} {{ item.employee?.lastName }}</td>
          <td>
            <span nz-tooltip [nzTooltipTitle]="item.icd10?.nameGeo"
                  class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
            >{{ item.icd10?.code }}</span>

            @if (item.icd102) {
              (<span nz-tooltip [nzTooltipTitle]="item.icd102?.nameGeo"
                     class="underline cursor-pointer decoration-dashed underline-offset-4 decoration-1 decoration-blue-500"
              >{{ item.icd102?.code }}</span>)
            }
          </td>
          <td>{{ item.ehrId }}</td>
          <td>{{ item.hospitalizationResult | typeOfHospitalization }}</td>

          <td nzLeft>{{ item.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td nzRight>
            <button
              nz-button
              nzType="default"
              nzSize="small"
              nzShape="circle"
              nz-dropdown
              [nzDropdownMenu]="rowActionsMenu"
              nzTrigger="click"
            >
              <i nz-icon nzType="more"></i>
            </button>
            <nz-dropdown-menu #rowActionsMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="openAmbulatoryCard(item)">
                  <span nz-icon nzType="file-text" nzTheme="outline" class="mr-2"></span>
                  ამბულატორიული ბარათი
                </li>
                <li nz-menu-item (click)="openSmallAmbulatoryCard(item)">
                  <span nz-icon nzType="file" nzTheme="outline" class="mr-2"></span>
                  მცირე ამბულატორიული ბარათი
                </li>
                <li nz-menu-item (click)="openObjectiveExaminations(item)">
                  <span nz-icon nzType="form" nzTheme="outline" class="mr-2"></span>
                  ობიექტური გამოკვლევები
                </li>
                <li nz-menu-item (click)="openMedicalInterventionProtocol(item)">
                  <span nz-icon nzType="medicine-box" nzTheme="outline" class="mr-2"></span>
                  ჩარევის ოქმი
                </li>
                <li nz-menu-divider></li>
                <li nz-menu-item (click)="printForm100(item)">
                  <span nz-icon nzType="printer" nzTheme="outline" class="mr-2"></span>
                  {{ 'ehr.ambulatoryCard.printForm100' | translate }}
                </li>
                <li nz-menu-item (click)="printPrescription(item)">
                  <span nz-icon nzType="file-text" nzTheme="outline" class="mr-2"></span>
                  {{ 'ehr.ambulatoryCard.printPrescription' | translate }}
                </li>
                <li nz-menu-item (click)="printInformedConsent(item)">
                  <span nz-icon nzType="audit" nzTheme="outline" class="mr-2"></span>
                  {{ 'ehr.ambulatoryCard.printInformedConsent' | translate }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
</div>
